import { EMetadataTypes, IMetadataEntry } from "../../metadata/types";
import { IUpdateProduct, IProductFormValues, IProduct } from "../types";
import { getTranslation, setTranslation } from "../../i18n";

const isArraysEqual = <T>(a: T[], b: T[]): boolean => {
  if (a.length !== b.length) return false;
  return [...a].sort().every((val, i) => val === [...b].sort()[i]);
}

export const mapProductToUpdate = (values: IProductFormValues, product: IProduct): Partial<IUpdateProduct> => {
  const updates: Partial<IUpdateProduct> = {};

  if (values.name !== getTranslation(product.name)) {
    updates.name = setTranslation(values.name);
  }

  if (values.status !== product.status) {
    updates.status = values.status;
  }

  if (values.brand !== getTranslation(product.brand)) {
    updates.brand = setTranslation(values.brand);
  }

  if (values.description !== getTranslation(product.description)) {
    updates.description = setTranslation(values.description);
  }

  // if (values.type !== product.type) {
  //   updates.type = values.type;
  // }

  if (values.temperature !== product.temperature) {
    updates.temperature = values.temperature;
  }

  if (values.displaySize !== product.displaySize) {
    updates.displaySize = values.displaySize;
  }

  if (values.pickingType !== product.pickingType) {
    updates.pickingType = values.pickingType;
  }

  if (values.heightMm !== product.heightMm) {
    updates.heightMm = values.heightMm;
  }

  if (values.weightKg !== product.weightKg) {
    updates.weightKg = values.weightKg;
  }

  if (values.volumeL !== product.volumeL) {
    updates.volumeL = values.volumeL;
  }

  if (values.lengthMm !== product.lengthMm) {
    updates.lengthMm = values.lengthMm;
  }

  const numericCategoryId = Number(values.categoryId);
  if (values.categoryId && !isNaN(numericCategoryId) && numericCategoryId !== product.categoryId) {
    updates.categoryId = numericCategoryId;
  }
  
  if (values.widthMm !== product.widthMm) {
    updates.widthMm = values.widthMm;
  }

  if (values.image !== product.images[product.images.length - 1]?.url) {
    updates.image = values.image;
  }

  if (!isArraysEqual(values.barcodes, product.barcodes)) {
    updates.barcodes = values.barcodes;
  }

  return updates;
};

export const mapMetadataToForm = (metadata: Record<string, string>, metadataEntries: IMetadataEntry[]): Record<string, string | boolean> => {
  const updatedMetadata: Record<string, string | boolean> = { ...metadata };
  Object.keys(updatedMetadata).forEach((key) => {
    const entry = metadataEntries.find((entry) => entry.name.toLowerCase() === key.toLowerCase()) as IMetadataEntry;
    if (!entry) {
      return;
    }
    if (entry.type === EMetadataTypes.Bool && updatedMetadata[key] === "true") {  
      updatedMetadata[key] = true;
      return;
    }
    if (entry.type === EMetadataTypes.Bool && updatedMetadata[key] === "false") {
      updatedMetadata[key] = false;
    }
  });
  return updatedMetadata;
}
